import * as React from 'react';
import * as ReactDOM from 'react-dom';

import './theme.css';

import App from './App';

ReactDOM.render(<App />, document.getElementById('app'));
